const linkedinPosts = [
    {
        image: "posts/japanesePhilosophies.png",
        text: "Some of the Best Japanese Philosophies to Live By ...",
        url: "https://www.linkedin.com/feed/update/urn:li:activity:7206676106521812992/"
    },
    {
        image: "posts/lightPollution.png",
        text: "Beyond air and water, there's another type of pollution silently affecting our planet...",
        url: "https://www.linkedin.com/feed/update/urn:li:activity:7175853823377252352/"
    },
    {
        image: "posts/laws.png",
        text: "Here are some fascinating laws that can transform the way you manage time and productivity...",
        url: "https://www.linkedin.com/feed/update/urn:li:activity:7209213694377934848/"
    },
]

const twitterPosts = [
    {
        text: "Ever heard of Shu - Ha - Ri ? Its a Japanese philosophy which means : Start by following established traditions (Shu) ...",
        url: 'https://x.com/Aayush9760/status/1808207282380902610'
    },
    {
        text: "In today's era of rapidly evolving tech, businesses should definitely shift to digitalizing their practices...",
        url: 'https://x.com/Aayush9760/status/1802042765984882794'
    },
    {
        text: "That's the Pareto Principle for you ! Focus on the 20% client, which provides 80% of revenue.",
        url: 'https://x.com/Aayush9760/status/1803503818442752229'
    },
]

export const socialMediaPosts = [
    {
        socialMedia : "Linkedin",
        details : {
            type : "Followers",
            cnt : "900+"
        },
        profileUrl : "https://www.linkedin.com/in/aayushsrivastava9760/",
        posts : linkedinPosts
    },
    {
        socialMedia : "X",
        details : {
            type : "Posts",
            cnt : "15+"
        },
        profileUrl : "https://x.com/Aayush9760",
        posts : twitterPosts
    },
]